import React, { useState } from "react";
import { useOrderMutation, useVerifyPayment } from "../_actions/payment";
import { useMe } from "../actions/auth";
import { useItemsFine } from "../_actions/app/items";
import { Button } from "antd";
import log from "cslog";

const RAZORPAYKEY = "rzp_live_RiGIXNKU65WT3j";
// const RAZORPAYKEY = "rzp_test_RvxEtY9MaYgSzQ";


const NAME = "Qureal AI";
const DESCRIPTION = "Qureal Technologies Private Limited";
const IMAGE =
    "https://api.qureal.com/passets/c90e4024-5d6a-4df0-b713-9362a6083eb9.png";

export function useRazorpay(onPaymentSuccess, onPaymentVerified, customVerifier = null, onPaymentCancel = null) {
    const [status, setStatus] = useState("idle");
    const defaultVerifier = useVerifyPayment((result) => {
        setStatus("success");
        onPaymentVerified(result);
    });
    
    // Use custom verifier if provided otherwise  fallback to default verifier(which was before)
    const activeVerifier = customVerifier || defaultVerifier;

    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    }

    const displayRazorpay = async (extra_options, prefill, notes, org_id) => {
        if (status === "pending") return;
        setStatus("pending");
        
        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

        if (!res) {
            alert("Razorpay SDK failed to load. Are you online?");
            return;
        }

        const options = {
            key: RAZORPAYKEY,
            currency: "INR",
            name: NAME,
            description: DESCRIPTION,
            image: IMAGE,
            prefill: prefill || {},
            handler: function (response) {
                localStorage.removeItem('qureal_incomplete_payment');
                onPaymentSuccess(response);
                setStatus("verifying");
                
                // detecting payment type based on razorpat response
                const isSubscription = !!response.razorpay_subscription_id;
                
            //    if subscription -> diff payload if order -> diff payload
                const payload = isSubscription 
                    ? {
                        // subscription verification payload
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_subscription_id: response.razorpay_subscription_id,
                        razorpay_signature: response.razorpay_signature,
                        org_id,
                    }
                    : {
                        // order verification payload
                        payment_id: response.razorpay_payment_id,
                        order_id: response.razorpay_order_id,
                        signature: response.razorpay_signature,
                        org_id,
                    };
                
                // Using the active verifier
                activeVerifier.mutate(payload);
            },
            modal: {
                ondismiss: function () {
                    console.log("Razorpay checkout dismissed by user");
                    localStorage.setItem('qureal_incomplete_payment', 'true');
                    setStatus("idle");
                    if (onPaymentCancel) onPaymentCancel();
                }
            },
            notes: {
                ...notes,
            },
            theme: {
                color: "#072a2bff",
            },
            ...extra_options,
        };
        console.log("rz options", options);
        const rzpy = new window.Razorpay(options);
        rzpy.on("payment.failed", function (response) {
            localStorage.setItem('qureal_incomplete_payment', 'true');
            setStatus("failed");
            if (onPaymentCancel) onPaymentCancel();
        });
        
        rzpy.open();
    };

    function payOrder(order, prefill, notes, org_id) {
        // order_id, amount
        displayRazorpay(order, prefill, notes, org_id);
    }

    function paySubscription(subscription, prefill, notes, org_id) {
        // subscription_id
        displayRazorpay(subscription, prefill, notes, org_id);
    }

    return { payOrder, paySubscription, status };
}

function QurealPay({
    prefill, // name, email, mobile
    notes,
    onSuccess = () => {},
    onFailed = () => {},
    order_id,
    subscription_id,
    amount, // required for order
}) {
    const [status, setStatus] = useState("idle");
    const {
        isLoading: loadingMe,
        data: dataMe,
        isSuccess: successMe,
    } = useMe(true);

    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    const displayRazorpay = async () => {
        if (status === "pending") {
            return;
        }
        console.log("Init payment");
        setStatus("pending");
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
            alert("Razorpay SDK failed to load. Are you online?");
            return;
        }
        // const amount = price * 100;
        const currency = "INR";

        const options = {
            key: RAZORPAYKEY,
            amount: amount.toString(),
            currency: currency,
            name: NAME,
            description: DESCRIPTION,
            image: IMAGE,
            // order_id: dataOrder?.order_id,
            handler: async function (response) {
                console.log("Success Handler response", response);
                setStatus(JSON.stringify(response));
                onSuccess(response);
                setStatus("success");
            },
            prefill: prefill || {},
            notes: {
                ...notes,
                qureal_order_id: "abcd",
            },
            theme: {
                color: "#000000",
            },
        };
        console.log("rz options", options);

        const rzpy = new window.Razorpay(options);

        rzpy.on("payment.authorized", function (response) {
            console.log("Payment triggered", response);
            onSuccess();
            setStatus("success");
        });

        rzpy.on("payment.captured", function (response) {
            console.log("Payment Captured", response);
            setStatus("success");
        });

        rzpy.on("payment.failed", function (response) {
            console.log("Payment Failed", response);
            onFailed();
            setStatus("failed");
        });

        rzpy.on("order.paid", function (response) {
            console.log("Order paid", response);
            onSuccess();
            setStatus("success");
        });

        rzpy.open();
    };

    return (
        <div>
            <Button
                disabled={status === "loading"}
                // loading={mutationOrder.isLoading}
                onClick={(e) => {
                    e.stopPropagation();
                    displayRazorpay();
                }}
            >
                Pay Now
            </Button>
        </div>
    );
}

export default QurealPay;
